import { api } from './client'
import type { Entry } from './entries'

export interface TagCount {
  name: string
  count: number
}

export function getUserTags(username: string): Promise<TagCount[]> {
  return api.get<TagCount[]>(`/users/${username}/tags`)
}

export function getEntriesByTag(username: string, tag: string): Promise<Entry[]> {
  return api.get<Entry[]>(`/users/${username}/tags/${encodeURIComponent(tag)}/entries`)
}
